<template>
<div>

    <div class="box partner-box" @click="partner_modal = true">
        <img src="https://assets.webbank.com/partners/jasper.svg" alt="Jasper Logo">
    </div>

<div class="modal" :class="{'is-active': partner_modal}">
  <div class="modal-background"></div>
  <div class="modal-content">
      <div class="box has-text-left">
          <h2 class="box-title">Our Brand Partner</h2>
          <br>
          <div class="has-text-centered">
            <img src="https://assets.webbank.com/partners/jasper.svg" alt="Jasper Logo">
          </div>
            <br>
            <p>In partnership with Jasper, WebBank is the issuer and lender of the Jasper Mastercard<sup>&reg;</sup>.
                For questions about your Jasper Mastercard, please call 1-855-398-1428 (domestic)
                or 1-650-382-4351 (international). If you are interested in learning more about applying for credit, click
            <a href="#" title="Apply at Jasper" @click="$emit('link-click', 'https://www.jaspercard.com/')">here</a>.</p>
            <br>
            <p><a href="#" title="Jasper Privacy Policy" @click="$emit('link-click', 'https://www.jaspercard.com/disclosures/Privacy_Policy-v2.pdf')">Jasper Privacy Policy</a></p>
            <br>
            <p><a href="#" title="Jasper Privacy Notice" @click="$emit('link-click', 'https://www.jaspercard.com/disclosures/privacy_notice.pdf')">Jasper Privacy Notice</a></p>
            <br>
            <button class="button is-primary is-light" @click="partner_modal = false">Close</button>

      </div>
  </div>
  <button class="modal-close is-large" aria-label="close" @click="partner_modal = false"></button>
</div>

</div>
</template>

<script>
export default {
    data: function () {
        return {
            partner_modal: false,
        }
    }
}
</script>
